//require('dotenv').config();
export default {
    GOOGLE: {
        GA_TRACKING_CODE: process.env.REACT_APP_GA_TRACKING_CODE,
      },
}